'use client';
import classNames from 'classnames';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoButton from 'eco-design/base/eco-button';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useId, useRef, useState } from 'react';
import { Autoplay, EffectFade, Navigation } from 'swiper';
import dynamic from 'next/dynamic';
import { Swiper, SwiperSlide } from 'swiper/react';
import CardImgSecond from './img/CardImgSecond';
import { VideoComp } from './VideoDialog';
import { getUrlGtm } from '@/utils/gtmUtils';

const VideoDialog: any = dynamic(() => import('./VideoDialog'), { ssr: true });
interface Props {
    initIndex: number;
    autoPlay: boolean;
    list: any;
    prefixCls: string;
    className?: string;
    tabLayout: string;
    size: 'default' | 'small';
}

export const BannerCom: React.FC<Props> = ({ initIndex, autoPlay, list, tabLayout, size, prefixCls, className, ...reset }) => {
    const { locale = 'us' } = getLocal();
    const swiperRef = useRef<any>(null);
    const [activeIndex, setActiveIndex] = useState(initIndex);
    const itemSlideChange = (swiperA: any) => {
        setActiveIndex(swiperA.realIndex);
    };

    const uuid = useId().replaceAll(':', 'a');

    const [isH5, setIsH5] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        setIsH5(isH5HandleClient());
    }, []);

    const switchGtm = (position: string, name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'banner_switch',
            position: `Homepage_topbanner_${position}`,
            button_name: name,

            __btn_id1: `kv3-swiper-control-${position}`,
            __btn_id2: `control-${position}`,
            __btn_type: 'common',
        });
    };

    const [videoDialog, setVideoDialog] = useState(false);
    const [videoDialog2, setVideoDialog2] = useState(false);

    return (
        <Swiper
            className={`${className} index-banner-swiper-compent ${className}-${uuid}`}
            onSlideChange={itemSlideChange}
            initialSlide={initIndex}
            pagination={false}
            navigation={{
                nextEl: `.${className}-${uuid} .swiper-button-next`,
                prevEl: `.${className}-${uuid} .swiper-button-prev`,
            }}
            loop={(list?.length ?? 0) > 1}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            speed={1000}
            allowTouchMove={isH5}
            autoplay={
                autoPlay
                    ? {
                          delay: 3000, // 轮播间隔时间（毫秒），默认3000
                          disableOnInteraction: false, // 用户操作后是否停止自动轮播，false表示不停止
                      }
                    : false
            }
            modules={[Navigation, Autoplay, EffectFade]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            key={
                !isH5
                    ? autoPlay
                        ? `${className}-autoplay-on`
                        : `${className}-autoplay-off`
                    : autoPlay
                    ? `${className}-autoplay-on-h5`
                    : `${className}-autoplay-off-h5`
            }
        >
            {list.map((itemA: any, index: number) => {
                const {
                    pc,
                    h5,
                    label,
                    title,
                    desc,
                    theme = 'white',
                    layout,
                    lHref,
                    lBtnContent,
                    rHref,
                    rBtnContent,
                    isVideo,
                    lBtnType,
                    lBtnVideoType = 'upload',
                    lBtnVideoPCUrl,
                    rBtnVideoType = 'upload',
                    rBtnVideoPCUrl,
                    lBtnVideoPc,
                    lBtnVideoH5,
                    rBtnType,
                    rBtnVideoPc,
                    rBtnVideoH5,
                } = itemA;
                const itemClassesA = classNames({
                    [`${prefixCls}-item`]: true,
                    [`${prefixCls}-item-${index}`]: true,
                    [`${prefixCls}-theme-${theme}`]: theme,
                    [size]: true,
                });

                const openLink = lHref && lBtnType === 'link' ? lHref : rHref && rBtnType === 'link' ? rHref : '';
                const linkLGtm = {
                    ...getUrlGtm(lHref, locale, {
                        list_name: 'Banner',
                        product_name: title,
                        button_name: lBtnContent,
                    }),
                    position: `Homepage_topbanner_${lBtnContent}`,

                    __btn_id1: `kv3-l-btn-${index}`,
                    __btn_id2: lHref,
                    __btn_type: 'href',
                };
                const linkRGtm = {
                    ...getUrlGtm(rHref, locale, {
                        list_name: 'Banner',
                        product_name: title,
                        button_name: rBtnContent,
                    }),
                    position: `Homepage_topbanner_${rBtnContent}`,

                    __btn_id1: `kv3-r-btn-${index}`,
                    __btn_id2: rHref,
                    __btn_type: 'href',
                };

                return (
                    <>
                        <SwiperSlide
                            className={itemClassesA}
                            key={`${index}`}
                            onClick={() => {
                                if (openLink) {
                                    window.open(openLink, '_self');
                                    gtm.push(lHref && lBtnType === 'link' ? linkLGtm : linkRGtm);
                                }
                            }}
                        >
                            <div className={`${prefixCls}-item-img`}>
                                {!isVideo && (
                                    <>
                                        {index === 0 && <EcoImg pc={pc} h5={h5} />}
                                        {index !== 0 && <CardImgSecond prefixCls={prefixCls} pc={pc} h5={h5} />}
                                    </>
                                )}
                                {isVideo && <VideoComp pc={pc} h5={h5} />}
                            </div>
                            <div className={`${prefixCls}-item-msg`}>
                                <div className={`${prefixCls}-item-info ${layout}`}>
                                    {label && <div className={`${prefixCls}-item-label`}>{label}</div>}
                                    {title && <div className={`${prefixCls}-item-title`}>{title}</div>}
                                    {desc && <div className={`${prefixCls}-item-desc`}>{desc}</div>}
                                    <div className={`${prefixCls}-box-btn`}>
                                        <EcoButton
                                            className={`GtmModuleData-btn-${lBtnType === 'link' ? 'href' : 'common'} kv3-l-btn-${index}`}
                                            stopPropagation
                                            data-btn-id={`item-l-${index + 1}`}
                                            lTheme={theme}
                                            lType="filled"
                                            lRadius="ellipse"
                                            lHref={lBtnType === 'link' ? lHref : undefined}
                                            lChildren={lBtnContent}
                                            lDataLayer={lBtnType === 'link' ? linkLGtm : undefined}
                                            onClick={() => {
                                                if (lBtnType === 'video') {
                                                    setVideoDialog(true);
                                                    gtm.push({
                                                        event: 'uaEvent',
                                                        event_name: 'video',
                                                        title_name: title,
                                                        position: 'Product Detail_1',

                                                        __btn_id1: `kv3-l-btn-${index}`,
                                                        __btn_id2: `item-l-${index + 1}`,
                                                        __btn_type: 'common',
                                                    });
                                                }
                                            }}
                                        />
                                        <EcoButton
                                            className={`GtmModuleData-btn-${rBtnType === 'link' ? 'href' : 'common'} kv3-r-btn-${index}`}
                                            stopPropagation
                                            data-btn-id={`item-r-${index + 1}`}
                                            lTheme={theme}
                                            lType="outlined"
                                            lRadius="ellipse"
                                            lHref={rBtnType === 'link' ? rHref : undefined}
                                            lChildren={rBtnContent}
                                            lIsWithRightArrow={true}
                                            lDataLayer={rBtnType === 'link' ? linkRGtm : undefined}
                                            onClick={() => {
                                                if (rBtnType === 'video') {
                                                    setVideoDialog2(true);
                                                    gtm.push({
                                                        event: 'uaEvent',
                                                        event_name: 'video',
                                                        title_name: title,
                                                        position: 'Product Detail_1',

                                                        __btn_id1: `kv3-r-btn-${index}`,
                                                        __btn_id2: `item-r-${index + 1}`,
                                                        __btn_type: 'common',
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {lBtnType === 'video' && (
                                <VideoDialog
                                    pc={lBtnVideoType === 'upload' ? lBtnVideoPc : lBtnVideoPCUrl}
                                    h5={lBtnVideoType === 'upload' ? lBtnVideoH5 : lBtnVideoPCUrl}
                                    open={videoDialog}
                                    onClose={() => setVideoDialog(false)}
                                />
                            )}
                            {rBtnType === 'video' && (
                                <VideoDialog
                                    pc={rBtnVideoType === 'upload' ? rBtnVideoPc : rBtnVideoPCUrl}
                                    h5={rBtnVideoType === 'upload' ? rBtnVideoH5 : rBtnVideoPCUrl}
                                    open={videoDialog2}
                                    onClose={() => setVideoDialog2(false)}
                                />
                            )}
                        </SwiperSlide>
                    </>
                );
            })}
            {(list?.length ?? 0) > 1 && (
                <>
                    <div className={`${prefixCls}-control`}>
                        <div
                            className={`swiper-button-prev GtmModuleData-btn-common kv3-swiper-control-Left`}
                            data-btn-id="control-Left"
                            onClick={() => switchGtm('Left', 'Left')}
                        ></div>
                        <div
                            className={`swiper-button-next GtmModuleData-btn-common kv3-swiper-control-Right`}
                            data-btn-id="control-Right"
                            onClick={() => switchGtm('Right', 'Right')}
                        ></div>
                    </div>
                    <ul className={`${prefixCls}-pagination ${prefixCls}-pagination-${tabLayout}`}>
                        {list.map((itemB: any, index: number) => {
                            const itemClassesB = classNames({
                                [`${prefixCls}-pagination-item`]: true,
                                [`${prefixCls}-pagination-active`]: index === activeIndex,
                            });
                            return (
                                <li
                                    key={index}
                                    className={`${itemClassesB} GtmModuleData-btn-common kv3-swiper-control-Bottom-${index + 1}`}
                                    data-btn-id={`control-Bottom-${index + 1}`}
                                    onClick={() => {
                                        if (swiperRef.current) {
                                            swiperRef.current.slideTo(index + 1);
                                            setActiveIndex(index);
                                        }
                                        switchGtm(`Bottom-${index + 1}`, itemB.tab_name);
                                    }}
                                >
                                    <div className={`${prefixCls}-pagination-title`}>{itemB.tab_name}</div>
                                    <div className={`${prefixCls}-pagination-line`}></div>
                                </li>
                            );
                        })}
                    </ul>
                </>
            )}
        </Swiper>
    );
};
